import React from 'react'
import { EyeIcon, EyeOffIcon, LockIcon, MailIcon } from './icons'

const NeutralSignInForm = ({ idPrefix, title, subtitle, emailPlaceholder, forgotHref, submitLabel, form }) => {
  const emailId = `${idPrefix}-email`
  const passwordId = `${idPrefix}-password`

  const onSubmit = (event) => {
    event.preventDefault()
    form.submit()
  }

  return (
    <form onSubmit={onSubmit} noValidate aria-busy={form.submitting}>
      <h1 className="na-card-title">{title}</h1>
      <p className="na-card-sub">{subtitle}</p>

      <div className="na-field">
        <label className="na-label" htmlFor={emailId}>Email Address</label>
        <div className="na-input-wrap">
          <span className="na-input-icon"><MailIcon /></span>
          <input
            id={emailId}
            className="na-input"
            type="email"
            placeholder={emailPlaceholder}
            autoComplete="email"
            value={form.email}
            onChange={(event) => form.setEmail(event.target.value)}
          />
        </div>
      </div>

      <div className="na-field">
        <label className="na-label" htmlFor={passwordId}>Password</label>
        <div className="na-input-wrap">
          <span className="na-input-icon"><LockIcon /></span>
          <input
            id={passwordId}
            className="na-input"
            type={form.showPassword ? 'text' : 'password'}
            placeholder="Enter your password"
            autoComplete="current-password"
            value={form.password}
            onChange={(event) => form.setPassword(event.target.value)}
          />
          <button
            type="button"
            className="na-eye"
            aria-label={form.showPassword ? 'Hide password' : 'Show password'}
            aria-controls={passwordId}
            onClick={form.toggleShowPassword}
          >
            {form.showPassword ? <EyeIcon /> : <EyeOffIcon />}
          </button>
        </div>
      </div>

      <div className="na-forgot">
        <a href={forgotHref}>Forgot password?</a>
      </div>

      <button type="submit" className="na-submit" disabled={form.submitting}>
        {form.submitting ? 'Signing in…' : submitLabel}
      </button>
    </form>
  )
}

export default NeutralSignInForm
